import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import { getShowOptions, type ShowOption } from '../hooks/useChartDisplayRange'

const DEFAULT_TOP_N = 10

interface ChartDisplayRangeProps {
  shown: number
  total: number
  value: ShowOption
  onChange: (value: ShowOption) => void
}

export const ChartDisplayRange = ({ shown, total, value, onChange }: ChartDisplayRangeProps) => {
  const showOptions = getShowOptions(total)

  return (
    <div className="flex flex-row-reverse items-center justify-items-end gap-4">
      <p className="text-xs text-foreground">
        {shown} of {total} shown
      </p>

      {total > DEFAULT_TOP_N && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-foreground">Show</span>

          <Select
            value={String(value)}
            onValueChange={(value) =>
              onChange(value === 'all' ? 'all' : (Number(value) as ShowOption))
            }
          >
            <SelectTrigger className="h-7 w-20 text-xs">
              <SelectValue />
            </SelectTrigger>

            <SelectContent>
              {showOptions.map((option) => (
                <SelectItem key={String(option)} value={String(option)} className="text-xs">
                  {option === 'all' ? 'All' : `Top ${option}`}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  )
}
